export enum IqbaPathSegment {
    Locobook = "locobook",
    Search = "search",
    Hosts = "hosts",
    Alternative = "alternative",
    Bookings = "bookings",
    AncillaryServices = "ancillaryServices",
}